import { render, staticRenderFns } from "./HighScore.vue?vue&type=template&id=65e6aa76&scoped=true&"
import script from "./HighScore.vue?vue&type=script&lang=js&"
export * from "./HighScore.vue?vue&type=script&lang=js&"
import style0 from "./HighScore.vue?vue&type=style&index=0&id=65e6aa76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e6aa76",
  null
  
)

export default component.exports